<div class="navigation-bar-root">
  <ng-container>
    <div class="useful-area">
      <ng-container *ngFor="let nav of navItems">
        <div
          id="{{'lnr-sidemenuitem-'+nav[0]}}"
          class="navigation-item"
          [ngClass]="{ active: home }"
          [routerLink]="'/' + nav[0]"
        >
          <mat-icon>{{ nav[1] }}</mat-icon>
          <span>{{ nav[2] }}</span>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
